import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';
import T, { LANGS, AREA_LABELS } from './translations';

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('mm_lang') : null;
    return saved && ['ru', 'tj', 'en'].includes(saved) ? saved : 'ru';
  });

  useEffect(() => {
    localStorage.setItem('mm_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => T[lang], [lang]);
  const areaLabel = useCallback((id) => (AREA_LABELS[id]?.[lang] ?? id), [lang]);

  const value = useMemo(() => ({ lang, setLang, t, langs: LANGS, areaLabel }), [lang, t, areaLabel]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within LangProvider');
  return ctx;
}
